/**
 * Normalize a US phone number to E.164 with the +1 country code:
 * strips all non-digits, drops a leading "1" country code, and returns
 * `+1` followed by the 10-digit national number. US-only audience.
 *
 * Returns the input unchanged when it does not contain exactly 10 (or 11
 * with a leading 1) digits, so schema validation can report the problem.
 */
export function normalizePhoneUS(raw: string): string {
  const digits = raw.replace(/\D/gu, "");
  const national =
    digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  return national.length === 10 ? `+1${national}` : raw;
}
